import React from 'react'
import withAnimatedMount from '../../animated_mount/animatedMount'
import { strings } from '../../../localization/strings'
import { AppBar, Toolbar, IconButton, Typography } from '@material-ui/core'
import BackIcon from '@material-ui/icons/ArrowBack'
import MailIcon from '@material-ui/icons/MailOutline'
import WebIcon from '@material-ui/icons/Public'
import {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    YoutubeIcon,
} from './contactIcons'

class Contact extends React.Component {
    state = {}

    renderToolbar = () => (
        <AppBar position="sticky" color="primary">
            <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="Menu"
                    onClick={() => this.props.history.goBack()}
                >
                    <BackIcon />
                </IconButton>
                <Typography
                    variant="h6"
                    color="inherit"
                    style={{ flexGrow: 1 }}
                >
                    {strings.contactPageTitle}
                </Typography>
                <div style={{ width: 48 }}></div>
            </Toolbar>
        </AppBar>
    )

    render() {
        var aStyle = {
            textDecoration: 'none',
            color: '#5555FF',
            clear: 'both',
            display: 'block',
        }

        var email = 'info.ar@pudolatam.com'
        var webUrl = 'www.pudo.com.ar'
        var facebookUrl = 'www.facebook.com/pudo.ar'
        var twitterUrl = 'twitter.com/PudoAr'
        var instagramUrl = 'www.instagram.com/pudoar/'
        var youtubeUrl = 'www.youtube.com/channel/UCQUgN8qs9M5mwoFW3TDrW2Q'

        return (
            <section className={'section-page'}>
                {/*{this.renderToolbar()}*/}
                <div style={{ maxWidth: 350, margin: 'auto' }}>
                    <>
                        <MailIcon color="primary" style={{ fontSize: 64 }} />
                        <br />
                        <Typography
                            variant="h6"
                            color="secondary"
                            style={{ flexGrow: 1 }}
                        >
                            {strings.contactEmailText}
                        </Typography>
                        <br />
                        <Typography
                            variant="h4"
                            style={{ flexGrow: 1, fontSize: 24 }}
                        >
                            <a
                                href={'mailto:' + email}
                                style={aStyle}
                                target="_top"
                            >
                                {email}
                            </a>
                        </Typography>
                    </>
                    <br />
                    <>
                        <WebIcon color="primary" style={{ fontSize: 64 }} />
                        <br />
                        <Typography
                            variant="h6"
                            color="secondary"
                            style={{ flexGrow: 1 }}
                        >
                            {strings.contactWebText}
                        </Typography>
                        <br />
                        <Typography
                            variant="h4"
                            style={{ flexGrow: 1, fontSize: 28 }}
                        >
                            <a
                                href={'http://' + webUrl}
                                style={aStyle}
                                target="_top"
                            >
                                {webUrl}
                            </a>
                        </Typography>
                        <br />
                        <IconButton href={'http://' + facebookUrl}>
                            <FacebookIcon
                                color="secondary"
                                style={{ fontSize: 36 }}
                            />
                        </IconButton>
                        <IconButton href={'http://' + twitterUrl}>
                            <TwitterIcon
                                color="secondary"
                                style={{ fontSize: 36 }}
                            />
                        </IconButton>
                        <IconButton href={'http://' + instagramUrl}>
                            <InstagramIcon
                                color="secondary"
                                style={{ fontSize: 36 }}
                            />
                        </IconButton>
                        <IconButton href={'https://' + youtubeUrl}>
                            <YoutubeIcon
                                color="secondary"
                                style={{ fontSize: 36 }}
                            />
                        </IconButton>
                    </>
                    <br />
                    <br />
                    <br />
                </div>
            </section>
        )
    }
}

export default (withAnimatedMount(Contact))
